import { get, post } from '../request.js';

/**
 * 查询积分概览
 */
export async function queryScoreOverview(params) {
  return get('/api/account_points/view_personal_points', params);
}

/**
 * 查询积分流水明细
 */
export async function queryScoreFlowDetail(params) {
  return post('/api/account_points_flow/page', params);
}

